import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getContactsData = createSelector(
    getModel,
    (model) => model?.contacts?.data || {},
);

export const getProjectsData = createSelector(
    getModel,
    (model) => model?.projects?.data || {},
);

export const getProposalsData = createSelector(
    getModel,
    (model) => model?.proposals?.data || {},
);
